import React from "react";
import { Loader } from "@progress/kendo-react-indicators";
import { NumericFormat } from "react-number-format";
const DashboardCard = (props) => {
    const { image, heading, loading, data, total, isCurrency, canClickValues, onClick, additionalTotalTitle, additionalTotal,sub_heading } = props;

    return (
        <>
            <div className="col-12 col-lg-6 col-xl-4 mb-2">
                <div className="dash-card-head py-3 px-4 mt-3">
                    <div className="d-flex align-items-center mb-2">
                        <img src={image} className="img-fluid me-2" style={{ height: '40px', }} alt="icon" />
                        <div style={{flex: 1}}></div>
                        <p className="dash-card-heading mb-0 ">{sub_heading}</p>
                    </div>
                    {loading ?
                        <Loader />
                        :
                        <div>
                            {
                                (data && data.length > 0) ? <>
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <h2 className="dash-card-heading mb-0 clinic-card-head" >{heading}</h2>
                                        {props.isCurrency ?
                                            <NumericFormat className="dash-card-text mb-0" value={total.toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                            : <p className="dash-card-text mb-0 clinic-card-head">{total}</p>
                                        }

                                    </div>

                                    {
                                        data.map((selectedItem) => {
                                            return <div className="d-flex justify-content-between align-items-center mb-1">
                                                <p className="region-text mb-0">{selectedItem.region}</p>
                                                {props.isCurrency ?
                                                    <NumericFormat className="region-num mb-0" value={selectedItem.onlineStaffCount.toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                                    :
                                                    <p style={{ cursor: canClickValues ? "pointer" : null }} className={canClickValues ? "text-theme mb-0" : "region-num mb-0"}
                                                        onClick={() => {
                                                            if (canClickValues) {
                                                                onClick(selectedItem.clicked)
                                                            }
                                                        }}
                                                    >{selectedItem.onlineStaffCount}</p>
                                                }
                                            </div>
                                        })
                                    }

                                    {
                                        (additionalTotal || additionalTotal === 0) &&
                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                            <p className="region-text mb-0">{additionalTotalTitle}</p>
                                            <p className={"region-num mb-0"}
                                            >{additionalTotal}</p>
                                        </div>
                                    }

                                </> :
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h2 className="dash-card-heading mb-0 clinic-card-head" >{heading}</h2>
                                        <p className="dash-card-text mb-0 clinic-card-head">{props.isCurrency ? '$00.00' : 0}</p>
                                    </div>
                            }


                        </div>
                    }

                </div>
            </div>
        </>
    )
}
export default DashboardCard;
